import $settings from 'src/include/settings.js';
import $log from 'src/include/log.js';
import $cfetch from 'src/include/cfetch.js';
import $UserSession from 'src/include/usersession.js';

/**
 * Class used to validate form fields 
 * @class FormFields
 * 
 * 
 * Example usage:
 * import FormFields from 'src/modules/forms/formfields.js';
 * const formFields = new FormFields(this.$UserSession);
 *

*/

class FormFields {
    constructor(userSession = $UserSession){
        this.$UserSession = userSession;
        this.$cfetch = $cfetch;
        this.$log = $log;
        this.$settings = $settings;
    }

    checkRequiredFields(fields){
        let missingFields = [];
        for (let i = 0; i < fields.length; i++) {
            if (fields[i].required && !fields[i].value && fields[i].value !== 0 && fields[i].value !== '0' && fields.display) {
                missingFields.push(fields[i].caption);
            }
        }
        if (missingFields.length > 0) {
            return {
            valid: false,
            fields: missingFields.join(', ')
            };
        }
        return { valid: true, fields: '' };
    }
  
  
}

export default FormFields;